import React from "react";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const filterOptions = createFilterOptions({
  stringify: option =>
    [option.baseName, option.leftLocation?.locationName, option.rightLocation?.locationName]
      .filter(Boolean)
      .join(" "),
});

const optionId = option => String(option?.leftLocation?.id || "");

export default function MissingCenterRackSelect({ options, value, onChange }) {
  const handleRemove = id => {
    onChange(value.filter(option => optionId(option) !== String(id)));
  };

  return (
    <Box>
      <Autocomplete
        multiple
        disableCloseOnSelect
        fullWidth
        options={options}
        value={value}
        onChange={(_, nextValue) => onChange(nextValue)}
        filterOptions={filterOptions}
        getOptionLabel={option => option.baseName}
        isOptionEqualToValue={(option, selected) => optionId(option) === optionId(selected)}
        ListboxProps={{ style: { maxHeight: 300, overflow: "auto" } }}
        slotProps={{
          popper: {
            placement: "bottom-start",
            modifiers: [
              { name: "flip", enabled: false },
              { name: "preventOverflow", enabled: false },
            ],
          },
        }}
        renderOption={(props, option, { selected }) => (
          <li {...props} key={optionId(option)}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option.baseName}
          </li>
        )}
        renderTags={() => null}
        renderInput={params => <TextField {...params} label="Storage Location" />}
      />
      {value.length > 0 && (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1.5 }}>
          {value.map(option => (
            <Chip
              key={optionId(option)}
              label={option.leftLocation.locationName}
              size="small"
              onDelete={() => handleRemove(option.leftLocation.id)}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}
